// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"20d7f9ce","172":"1060f0ef","511":"5e562ad2"}[chunkId] + ".chunk.js";
};